/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_BackInputs */

const en_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const es_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atrás`)
};

const fr_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const ja_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const zh_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const ar_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجوع`)
};

const id_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali`)
};

const it_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

const ru_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const pt_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const ko_action_back = /** @type {(inputs: Action_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤로`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Action_BackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_back = /** @type {((inputs?: Action_BackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_BackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_back(inputs)
	if (locale === "es") return es_action_back(inputs)
	if (locale === "fr") return fr_action_back(inputs)
	if (locale === "de") return de_action_back(inputs)
	if (locale === "ja") return ja_action_back(inputs)
	if (locale === "zh") return zh_action_back(inputs)
	if (locale === "ar") return ar_action_back(inputs)
	if (locale === "id") return id_action_back(inputs)
	if (locale === "it") return it_action_back(inputs)
	if (locale === "ru") return ru_action_back(inputs)
	if (locale === "pt") return pt_action_back(inputs)
	return ko_action_back(inputs)
});